module.exports = {
  title: 'Informácie o cookies!',
  description: 'Kliknutím na "PRIJAŤ VŠETKO" budou uloženy cookies funkční, výkonnostní, analytické i marketingové - dokážeme vám tak umožnit pohodlné používání webu a měřit funkčnost našeho webu. Své preference můžete snadno upravit kliknutím na Nastavení cookies.',
  primary_btn: {
      text: 'PRIJAŤ VŠETKO',
      role: 'accept_all'      //'accept_selected' or 'accept_all'
  },
  secondary_btn: {
      text: 'Nastavení cookies',
      role: 'settings'       //'settings' or 'accept_necessary'
  },
  revision_message: '<br><br> Dear user, terms and conditions have changed since the last time you visisted!'
}
